import styled from 'styled-components'

export const MainWrapper = styled.section`
    .main-wrap{
        padding-left: 20px;
        padding-right: 20px;
    }
    
    .sliderMainColC{
        padding-left: 66px;
        padding-right: 66px;
    }
    .slick-prev, .slick-next{
        width: 66px;
        height: 66px;
    }
    .slick-prev {
        left: -76px;
    }
    .slick-next {
        right: -76px;
    }
    body.rtl &{
        .slick-next {
           left: unset;
        }
    }

    @media (max-width: 767px) {
        .sliderMainColC{
            padding-right: calc(var(--bs-gutter-x) * .5);
            padding-left: calc(var(--bs-gutter-x) * .5);
        }
        .main-wrap{
            padding-right: 0;
            padding-left: 0;
        }
        .slick-next, .slick-prev{
            z-index: 1;
            width: 46px;
            height: 46px;
        }
        .slick-next {
            right: 25px;
        }
        .slick-prev {
            left: 25px;
        }
    }
`


export const ProductTabWapper = styled.div`

    .tabWrapperProduct{
        display: flex;
        // flex-direction: row-reverse;
        width: 100%;
        border-top: 1px solid var(--text);
        border-bottom: 1px solid var(--text);
        // justify-content: space-evenly;
        gap: 15px;
        margin-bottom: 30px;
        margin-top: 0px;
        padding-left: 15px;
        padding-right: 15px;
        // overflow-x: auto;
        /* justify-content: center; */
    }
    .TabButtonWrapper{
        padding: 8px 24px;
        margin:15px 0;
        position: relative;
        cursor: pointer;
        border-radius: 20px;
        background-color: transparent;
        border: 1px solid var(--themeColor);
        transition: all .3s ease-in-out;
        // margin: 0 10px 0 10px;
        
        span{
            display: flex;
            align-items: center;
            color: var(--themeColor);
            font-size: 16px;
            font-family: var(--medium);
            text-align: center;
            white-space: nowrap;
            transition: all .3s ease-in-out;
            
        }
        &.active {
            background-color: var(--themeColor);
        }
        &.active span {
            font-family: var(--medium);
            color: var(--bg2);
        }
        &:hover{
            background-color: var(--themeColor);
            span{
                color: var(--bg2);
            }
            // background: var(--gradientDark);
            // border-radius:20px;
            // box-shadow: 0px 0px 5px -5px rgba(172,131,34,0.9);
            // -webkit-box-shadow: 0px 0px 5px -5px rgba(172,131,34,0.9);
            // -moz-box-shadow: 0px 0px 5px -5px rgba(172,131,34,0.9);
            
        }
        body.rtl &{
            span{
                font-family: var(--arRegular);
            }
        }
        
    }

    @media (max-width: 1199px) {
        .tabWrapperProduct{
            gap: 7px;
            overflow-x: auto;
        }
        
    } 
`

export const PortfolioColWrap = styled.div`
    .portfolioCol{
        padding-left: 15px;
        padding-right: 15px;
    }
    .portfolioIcon{
        height: 374px;
        border-radius: 16px;
        overflow: hidden;
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    @media (max-width: 767px) {
        padding: 0;
    }
` 